import { setIdiomas } from './comun'

export function iniciarMenu (claseDelItem) {
  const mm = document.querySelector('nav.menu')
  if (!mm.classList.contains('iniciado')) {
    mm.classList.add('iniciado')
    document.querySelector('.hamburguesa').addEventListener('click', evento => {
      evento.preventDefault()
      if (mm.classList.contains('abierto')) {
        mm.classList.remove('abierto')
      } else {
        mm.classList.add('abierto')
      }
    })
    if (document.querySelector('.' + claseDelItem)) {
      document.querySelector('.' + claseDelItem).classList.add('menuActual')
    }
    // 
    let submenues = mm.querySelectorAll('span.submenu > a')
    for (let submenu of submenues) {
      submenu.addEventListener('click', abreCierraSubmenu)
    }
    function abreCierraSubmenu (evento) {
      evento.preventDefault()
      if (!window.matchMedia('(min-width: 768px)').matches) {
        let submenu = this.parentNode
        if (submenu.classList.contains('abierto')) {
          submenu.classList.remove('abierto')
          this.querySelector('.ico.cerrar').style.display = 'none'
          this.querySelector('.ico.abrir').style.display = 'inline-block'
        } else {
          submenu.classList.add('abierto')
          this.querySelector('.ico.cerrar').style.display = 'inline-block'
          this.querySelector('.ico.abrir').style.display = 'none'
        }
      }
    }
    //
    const cabeza = document.querySelector('body > header')
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 50) {
        cabeza.classList.add('claro')
      } else {
        cabeza.classList.remove('claro')
      }
    })
  }
  // Muestra menú de idiomas si hay idioma en el URL
  if (setIdiomas.includes(document.location.pathname.split('/')[1])) {
    mm.querySelector('.menuIdiomas').classList.remove('oculto')
  } else {
    mm.querySelector('.menuNormal').classList.remove('oculto')
  }
}
